import React, { useState } from 'react';
import './Gallery.css';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const images = [
    { src: '/aminstratice_building.jpeg', alt: 'Administration Building' },
    { src: '/boys_hostel.jpeg', alt: 'Boys Hostel' },
    { src: '/clock_tower.jpeg', alt: 'Clock Tower' },
    { src: '/dining_hall.jpeg', alt: 'Dining Hall' },
    { src: '/directo_bungalow.jpeg', alt: "Director's Bungalow" },
    { src: '/entrance_iiitdmk.jpeg', alt: 'IIITDM Kurnool Entrance' },
    { src: '/girls_hostel.jpeg', alt: 'Girls Hostel' },
    { src: '/rupala_sangameswara_swamy_temple.jpeg', alt: 'Rupala Sangameswara Swamy Temple' },
    { src: '/seminar_hall_complex.jpeg', alt: 'Seminar Hall Complex' },
    { src: '/sports_arena.jpeg', alt: 'Sports Arena' },
    { src: '/staff_quarters.jpeg', alt: 'Staff Quarters' },
    { src: '/Top_Viw_of_Jagganaathgattu_hills.jpeg', alt: 'Top View of Jagannathagattu Hills' },
  ];

  const openLightbox = (img, index) => {
    setSelectedImage(img);
    setCurrentImageIndex(index);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  const goToPrevious = (e) => {
    e.stopPropagation();
    const newIndex = currentImageIndex === 0 ? images.length - 1 : currentImageIndex - 1;
    setCurrentImageIndex(newIndex);
    setSelectedImage(images[newIndex]);
  };

  const goToNext = (e) => {
    e.stopPropagation();
    const newIndex = currentImageIndex === images.length - 1 ? 0 : currentImageIndex + 1;
    setCurrentImageIndex(newIndex);
    setSelectedImage(images[newIndex]);
  };

  return (
    <div 
      className="gallery-page gallery-page-padding"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/Top_Viw_of_Jagganaathgattu_hills.jpeg)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}
    >
      <div className="gallery-container">
        <h1 className="gallery-title">Photo Gallery</h1>
        
        <div className="gallery-grid">
          {images.map((img, index) => (
            <div className="gallery-item" key={index} onClick={() => openLightbox(img, index)}>
              <img src={img.src} alt={img.alt} className="gallery-img" />
              <div className="gallery-overlay">
                <span className="gallery-overlay-text">{img.alt}</span>
              </div>
            </div>
          ))}
        </div>

        {selectedImage && (
          <div className="gallery-lightbox" onClick={closeLightbox}>
            <button className="gallery-nav-btn gallery-nav-prev" onClick={goToPrevious}>
              &#10094;
            </button>
            <div className="gallery-lightbox-content">
              <img src={selectedImage.src} alt={selectedImage.alt} className="gallery-lightbox-img" />
              <div className="gallery-lightbox-caption">
                {selectedImage.alt}
                <span className="gallery-image-counter"> ({currentImageIndex + 1} of {images.length})</span>
              </div>
            </div>
            <button className="gallery-nav-btn gallery-nav-next" onClick={goToNext}>
              &#10095;
            </button>
            <span className="gallery-close-btn" onClick={closeLightbox}>&times;</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default Gallery;
